import { Pipe, PipeTransform } from "@angular/core";
import { getArchiveIcon } from "../support/archive-icon";

@Pipe({
  name: "archiveIcon",
  standalone: false
})
export class ArchiveIconPipe implements PipeTransform {
  transform(value: string): string {
    return getArchiveIcon(value);
  }
}
